<template>
  <div>
    <img class="index-logo" src="static/indexnoslus.svg">
    <h4 style="margin-top:30px">{{$t("webformtaxpay.msg.login_title")}}</h4>
    <div style="padding: 14px;">
      <div class="bottom clearfix">
        <div style="height:54px">
          <transition-group name="fade">
            <div v-show="data.showMsg" key="t1" :style="`color:${data.color[data.color.set]}`">{{data.show_message}}</div>
          </transition-group>
        </div>
        <div style="margin-top:30px;text-align:left;margin-bottom:5px"><b>{{macro === 'noslus_cz' ? 'Heslo' : $t("webform.lbl.pin_code")}}</b></div>
        <el-input
          @keyup.native.enter="btnLogin()"
          :placeholder="`zde vložte ${macro === 'noslus_cz' ? 'heslo' : 'váš PIN kód'}`"
          :type="`${macro === 'noslus_cz' ? 'password' : 'primary'}`"
          :show-password="macro === 'noslus_cz'"
          v-model="tmp_pin"
          clearable>
        </el-input>
        <div :style="`text-align:left;margin-top:'-5px'`">
          <div style="line-height:36px;display:block;height:56px">
            <el-col :span="24">
              <transition name="fade">
                <el-button v-show="showSendPin && macro !== 'noslus_cz'" type="text" @click="btnResend" :disabled="disableSendPin">{{$t("webform.msg.resend_pin")}}</el-button>
              </transition>
            </el-col>
            &nbsp;
          </div>
        </div>
        <div :style="`text-align:right;`">
          <el-button
            type="danger" :class="`${isDisabledPin ? 'btn-confirm-disabled' : 'btn-confirm'}`"
            style="width:calc(100%);"
            :disabled="isDisabledPin" @click="btnLogin()">Přihlásit</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */

export default {
  props: ['data', 'pin', 'showSendPin', 'disableSendPin', 'isDisabledPin', 'screen_w', 'macro'],
  data () {
    return {
      tmp_pin: ''
    }
  },
  watch: {
    tmp_pin: function (val) {
      this.changePin()
    }
  },
  created () {
    console.log('.::. login.vue created .::.')
  },
  methods: {
    btnLogin () {
      this.$emit('btnLogin')
    },
    btnResend () {
      this.$emit('btnResend')
    },
    changePin () {
      this.$emit('pin', this.tmp_pin)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WebLogin/login.vue